// MT home dashboard (zone layout) strings: mtdToday. Keys use the "mtd-" prefix.
// Shared words (today, sales, service, labor, metric, comp, close, no-data,
// rankings) and the shell's mtd-quick-table / mtd-full-report are reused
// from their existing domains rather than copied here.
export default {
  en: {
    'mtd-today-meta': 'Live · every {minutes} min',
    'mtd-today-meta-updated': 'Live · every {minutes} min · updated {time}',
    'mtd-vs-ly': 'vs LY',
    'mtd-today-group': 'Group',
    'mtd-today-value': 'Value',
    'mtd-today-all-metrics': 'All Today metrics',
  },
  es: {
    'mtd-today-meta': 'En vivo · cada {minutes} min',
    'mtd-today-meta-updated':
      'En vivo · cada {minutes} min · actualizado {time}',
    'mtd-vs-ly': 'vs AA',
    'mtd-today-group': 'Grupo',
    'mtd-today-value': 'Valor',
    'mtd-today-all-metrics': 'Todas las métricas de hoy',
  },
  fr: {
    'mtd-today-meta': 'En direct · toutes les {minutes} min',
    'mtd-today-meta-updated':
      'En direct · toutes les {minutes} min · mis à jour {time}',
    'mtd-vs-ly': 'vs AD',
    'mtd-today-group': 'Groupe',
    'mtd-today-value': 'Valeur',
    'mtd-today-all-metrics': "Tous les indicateurs d'aujourd'hui",
  },
  'fr-ca': {
    'mtd-today-meta': 'En direct · toutes les {minutes} min',
    'mtd-today-meta-updated':
      'En direct · toutes les {minutes} min · mis à jour {time}',
    'mtd-vs-ly': 'vs AD',
    'mtd-today-group': 'Groupe',
    'mtd-today-value': 'Valeur',
    'mtd-today-all-metrics': "Tous les indicateurs d'aujourd'hui",
  },
};
